window.CVTChart = window.CVTChart || {};

window.CVTChart.renderChart = function ({ hydroURL, api_url, chartContainer, months }) {
  if (hydroURL && api_url && chartContainer) {
    const fetchURL = `${hydroURL}/api/stock?stock_url=${encodeURIComponent(api_url)}`;

    fetch(fetchURL)
      .then((response) => response.json())
      .then((data) => {
        if (Array.isArray(data)) {
          const now = new Date();
          const monthsAgo = new Date(now.getFullYear(), now.getMonth() - months, 1);

          const filtered = data
            .map(([date, price]) => [
              typeof date === 'string' ? new Date(date).getTime() : date,
              price,
            ])
            .filter(([timestamp]) => timestamp >= monthsAgo.getTime())
            .sort((a, b) => a[0] - b[0]); // sort ascending

          Highcharts.chart(chartContainer, {
            chart: { zoomType: 'x' },
            title: { text: '' },
            xAxis: { labels: { style: { fontSize: '14px' } }, type: 'datetime' },
            yAxis: {
              labels: {
                style: { fontSize: '14px' },
                formatter: function () {
                  if (this.value >= 0) {
                    return '$' + this.value;
                  } else {
                    return '-$' + this.value;
                  }
                },
              },
              title: { text: '' },
            },
            legend: { enabled: false },
            plotOptions: {
              area: {
                fillColor: {
                  stops: [
                    [0, Highcharts.getOptions().colors[0]],
                    [1, Highcharts.color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')],
                  ],
                },
                marker: { radius: 2 },
                lineWidth: 2,
                states: { hover: { lineWidth: 2 } },
                threshold: null,
              },
            },
            series: [
              {
                type: 'area',
                color: '#B58A51',
                name: 'price ',
                tooltip: { valuePrefix: '$' },
                data: filtered,
              },
            ],
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }
};
